import { computed, Directive, effect, input } from '@angular/core';
import {
  NavigationExtras,
  Params,
  Router,
  RouterLink,
  UrlSerializer,
} from '@angular/router';
import { toInternationalizedRoute } from './i18n-routes';

@Directive({
  standalone: true,
  selector: '[i18nRouterLink]',
  host: {
    '[attr.href]': 'href()',
  },
  hostDirectives: [RouterLink],
})
export class i18nRouterLinkDirective {
  i18nQueryParams = input<Params | null | undefined>();
  i18nRouterLink = input.required<string | any[] | null | undefined>();
  href = computed(() => {
    const link = this.i18nRouterLink();
    const params = this.i18nQueryParams();
    if (typeof link === 'string') return toInternationalizedRoute(link);
    if (Array.isArray(link))
      return this.resolveHref(toInternationalizedRoute(link), {
        queryParams: params ?? undefined,
      });
    return link ?? undefined;
  });
  target = input<string>();

  constructor(
    private readonly routerLink: RouterLink,
    private router: Router,
    private urlSerializer: UrlSerializer,
  ) {
    effect(
      () =>
        (this.routerLink.routerLink = toInternationalizedRoute(
          this.i18nRouterLink(),
        )),
    );
    effect(() => (this.routerLink.queryParams = this.i18nQueryParams()));
    effect(() => (this.routerLink.target = this.target()));
  }

  resolveHref(commands: any[], extras?: NavigationExtras) {
    const urlTree = this.router.createUrlTree(commands, extras);
    return this.urlSerializer.serialize(urlTree);
  }
}
